import MDBox from "../../Components/MDBox";
import React from "react";
import MDTypography from "../../Components/MDTypography";
import {ButtonBase, Grid} from "@mui/material";
import PageLayout from "../../Components/LayoutContainers/PageLayout";

import G1 from '../../Asset/images/g1.png'
import G2 from '../../Asset/images/doc34.png'
import G3 from '../../Asset/images/doc1.png'
import G4 from '../../Asset/images/g4.png'
import Pl from '../../Asset/images/pl.png'
import PR from '../../Asset/images/pr.png'
import Cloud from '../../Asset/images/cloud.png'
import Phone from '../../Asset/images/phone.png'
import Telegram from '../../Asset/images/telegram.png'
import Gmail from '../../Asset/images/gmail.png'
import kids from '../../Asset/images/kids.png'
import Mive from '../../Asset/images/mive.png'
import SMive from '../../Asset/images/miveside.png'
import {useNavigate} from "react-router-dom";

function Home() {
    const navigate = useNavigate();
    return <PageLayout>
        <MDBox sx={{backgroundColor: {xs: "#D7F4FC", sm: "unset"}}}>
            <MDBox sx={{display: {xs: 'none', sm: 'block'}}}>

                <img height={500} width={"100%"} src={require("../../Asset/images/Group31.png")} alt={"kids"}
                     style={{position: "absolute", left: 0}}/>
            </MDBox>
            <MDBox sx={{display: {sm: 'none', xs: 'block'}}}>

                <img width={"100%"} src={require("../../Asset/images/abr-bg.png")} alt={"kids"}
                     style={{position: "absolute", left: 0, right: 0, bottom: 0, top: 0}}/>
            </MDBox>
            <MDBox height={375} sx={{
                zIndex: 10,
                position: "relative",
                px: 10,
                py: 2,
                alignContent: {xs: "center", sm: "unset"},
                textAlign: {xs: "center", sm: "unset"}
            }}>

                <MDTypography color={"#180070"} fontWeight={"bold"} fontSize={"3rem"}>قهرمان سلامت</MDTypography>
                <MDTypography color={"#180070"}>سلامت دانش آموزان ، سرمایه ای برای آینده</MDTypography>
            </MDBox>

            <MDBox bgColor={"#FFC300"} mt={"6px"} height={400}>
                <Grid container>
                    <Grid item xs={4} sx={{display: {xs: 'none', sm: 'block'}}}>
                        <img src={Mive} alt={"Mive"} height={400} width={"100%"}/>
                    </Grid>
                    <Grid item xs={12} sm={8} md={4} alignSelf={"center"}
                          sx={{p: {xs: '15px', md: 'unset', sm: '2px'}}}>

                        <MDTypography sx={{fontSize: {xs: 18, md: 14, lg: 18}}} lineHeight={2.5}>
                            چاقی فقط به معنی چاق بودن نیست؛ می‌تونه انرژی‌تون رو بگیره، باعث بشه تو ورزش‌ها کم
                            بیارید یا
                            زود خسته بشید. حتی ممکنه باعث بشه تو جمع‌ها اعتماد به نفس کمتری داشته باشید. ولی با
                            انتخاب
                            غذاهای بهتر و یکم تحرک بیشتر، می‌شه زندگی شادتر و پرانرژی‌تری داشت.
                            <span style={{color: "#006FFF"}}>
                            از الان برای خودت
                            قوی‌تر
                            قدم بردار!
                            </span>

                        </MDTypography>
                    </Grid>
                    <Grid item xs={4} alignContent={"center"} textAlign={"center"}
                          sx={{display: {xs: 'none', md: 'block', sm: 'none'}}}>
                        <img width={"100%"} src={SMive} alt={"Mive"} height={250}/>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox bgColor={"#D7F4FC"} minHeight={400}>
                <Grid container flexDirection={"column"}>
                    <Grid item alignSelf={"center"} pt={2} xs={12}>
                        <MDTypography color={"#000000"} sx={{textAlign: "center"}} fontWeight={"bold"} fontSize={25}>
                            برای ثبت اطلاعات در وبسایت<span style={{
                            fontSize: 34,
                            color: "#FFC300",
                            fontWeight: "bold",
                            WebkitTextStroke: "1px black",
                            textShadow: " 0 0 3px #000"
                        }}> قهرمان سلامت </span>برروی یکی از عناوین زیر کلیک کنید
                        </MDTypography>
                    </Grid>
                    <Grid container textAlign={"center"}>
                        <Grid sx={{cursor: "pointer"}} onClick={() => navigate("/login")} item container
                              justifyContent={"center"} direction={"column"} xs={6} md={6} lg={3}>
                            <Grid item container justifyContent={"center"} mb={2}>

                                <MDBox bgColor={"white"} p={2} border={"5px dashed #005CB1"} borderRadius={"100%"}>
                                    <img src={G1} alt={"g1"} style={{borderRadius: "100%"}} width={"150px"}
                                         height={"150px"}/>
                                </MDBox>
                            </Grid>
                            <MDTypography fontWeight={"bold"} fontSize={"28px"}>دانش آموز</MDTypography>
                        </Grid>
                        <Grid sx={{cursor: "pointer"}} onClick={() => navigate("/login")} item container
                              xs={6} md={6} lg={3}
                              justifyContent={"center"}>

                            <Grid item container justifyContent={"center"} mb={2}>

                                <MDBox bgColor={"white"} p={2} border={"5px dashed #005CB1"} borderRadius={"100%"}>
                                    <img src={G2} alt={"g1"} style={{borderRadius: "100%"}} width={"150px"}
                                         height={"150px"}/>
                                </MDBox>
                            </Grid>
                            <MDTypography fontWeight={"bold"} fontSize={"28px"}>پزشک</MDTypography>
                        </Grid>
                        <Grid sx={{cursor: "pointer"}} onClick={() => navigate("/login")} item container
                              justifyContent={"center"} xs={6} md={6} lg={3}>
                            <Grid item container justifyContent={"center"} mb={2}>

                                <MDBox bgColor={"white"} p={2} border={"5px dashed #005CB1"} borderRadius={"100%"}>
                                    <img src={G3} alt={"g1"} style={{borderRadius: "100%"}} width={"150px"}
                                         height={"150px"}/>
                                </MDBox>
                            </Grid>
                            <MDTypography fontWeight={"bold"} fontSize={"28px"}>والدین</MDTypography>
                        </Grid>
                        <Grid sx={{cursor: "pointer"}} onClick={() => navigate("/login")} item container
                              justifyContent={"center"} xs={6} md={6} lg={3}>
                            <Grid item container justifyContent={"center"} mb={2}>

                                <MDBox bgColor={"white"} p={2} border={"5px dashed #005CB1"} borderRadius={"100%"}>
                                    <img src={G4} alt={"g1"} style={{borderRadius: "100%"}} width={"150px"}
                                         height={"150px"}/>
                                </MDBox>
                            </Grid>
                            <MDTypography fontWeight={"bold"} fontSize={"28px"}>مربی</MDTypography>
                        </Grid>

                    </Grid>
                </Grid>
            </MDBox>
            <MDBox bgColor={"#4F2788"} height={400} alignContent={"center"}>
                <MDBox
                    sx={{position: "absolute", filter: "blur(3px)", display: {xs: 'block', sm: 'block', lg: 'none'}}}>
                    <img src={PR} alt={"pl"} width={"100%"} height={"310x"}/>
                </MDBox>
                <Grid container>
                    <Grid item xs={3} sx={{display: {xs: 'none', sm: 'none', lg: 'block'}}}>
                        <img src={PR} alt={"pl"} height={"310x"}/>

                    </Grid>
                    <Grid zIndex={99} textAlign={"center"} item direction={"column"} xs={12} md={12} lg={6}
                          alignContent={"center"}
                          justifyContent={"center"}>
                        <Grid item xs={10}>
                            <MDTypography color={"white"} fontSize={"28px"} sx={{zIndex: 10}}>
                                برای ارسال پیام به سایر کاربرها لطفا ابتدا وارد حساب کاربری خود شوید و سپس با انتخاب
                                کاربر
                                مورد نظر پیام خود را ارسال کنید
                            </MDTypography>
                        </Grid>
                        <Grid item alignSelf={"center"} mt={4}>
                            <ButtonBase onClick={() => navigate("/login")}>
                                <MDBox bgColor={"#D7F4FC"} p={2} sx={{borderRadius: "6px"}}>
                                    <MDTypography color={"#4F2788"} fontWeight={"bold"} fontSize={"24px"}>
                                        ورود به حساب کاربری
                                    </MDTypography>
                                </MDBox>
                            </ButtonBase>
                        </Grid>
                    </Grid>
                    <Grid xs={3} sx={{display: {xs: 'none', sm: 'none', lg: 'block'}}}>
                        <img src={Pl} alt={"pl"} height={"310x"} width={"100%"}/>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox bgColor={"#D7F4FC"} minHeight={400}>
                <Grid container minHeight={"300px"}>
                    <Grid container xs={3} height={"400px"} sx={{display: {xs: 'none', lg: 'flex', sm: 'none'}}}>
                        <img src={Cloud} alt={"Cloud"}/>
                    </Grid>
                    <Grid item  xs={12} sm={6} md={6} alignContent={"center"} textAlign={"center"}>
                        <MDTypography fontWeight={"bold"} fontSize={22} sx={{p:1}}>
                            "ما به سلامت دانش‌آموزان اهمیت می‌دهیم و همواره در کنار شما هستیم. با بهره‌گیری از دانش روز
                            و تخصصی‌ترین ابزارها، مسیر رشد سالم و پایش منظم را برای فرزندانتان فراهم کرده‌ایم. برای کسب
                            اطلاعات بیشتر یا ارتباط با تیم پشتیبانی ما، از طریق راه‌های ارتباطی زیر اقدام کنید."
                        </MDTypography>
                    </Grid>
                    <Grid item container  xs={12} sm={3} md={3  } direction={"column"} alignItems={"center"} justifyContent={"center"}
                          gap={"2rem"}>
                        <Grid container justifyContent={"center"}>
                            <Grid item>
                                <MDTypography>09121127744</MDTypography>
                            </Grid>
                            <Grid item>
                                <img src={Phone} alt=""/>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent={"center"}>
                            <Grid item>
                                <MDTypography>09121127744</MDTypography>
                            </Grid>
                            <Grid item>
                                <img src={Telegram} alt=""/>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent={"center"}>
                            <Grid item>
                                <MDTypography sx={{lineBreak:"anywhere"}}>ghahremansalamat@gmail.com</MDTypography>
                            </Grid>
                            <Grid item>
                                <img src={Gmail} alt=""/>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </MDBox>
        </MDBox>
    </PageLayout>
}

export default Home;